import { ReactElement } from 'react'
import SignupStudent from '../../components/Auth/SignupStudent'
import { PageTitle } from '../../components/atoms'
import AuthPageLayout from '../../components/global/AuthPageLayout'

export const pageTitle = 'Sign Up - Create your password'
export const idCreatePasswordPageMainContent = 'create-password-page-main-content'

function SignUp (): ReactElement {
  return (
    <AuthPageLayout mainId={idCreatePasswordPageMainContent}>
      <PageTitle title={pageTitle} />
      <section className='flex justify-center w-full md:w-auto'>
        <SignupStudent />
      </section>
    </AuthPageLayout>
  )
}

export default SignUp
